import compose from "ramda/es/compose";
import flatten from "ramda/es/flatten";
import map from "ramda/es/map";
import mapObjIndexed from "ramda/es/mapObjIndexed";
import pathOr from "ramda/es/pathOr";
import reject from "ramda/es/reject";
import values from "ramda/es/values";
const hasError = (file)=>Boolean(file.error);
const rejectError = reject(hasError);
/**
 * get all files from form flatten with fieldId, errors are rejected
 *
 * @documented
 * @category Object
 *
 * @param {Object} fileInputsWithPath - key value object with {[fileInputName]: fileInputValue}
 * @param {Object} formData - formData
 * @example
 *
 * 	getFlattenFiles(fileInputsWithPath, formData)
 *	// result
 * 	[
 *		{ fieldId: 'file1', name: 'aa.txt' },
 *		{ fieldId: 'file2', name: 'cc.txt' },
 *		{ fieldId: 'file2', name: 'bb.txt' },
 *	]
 *
 */ const getFlattenFiles = (fileInputsWithPath, formData)=>compose(rejectError, flatten, values, mapObjIndexed((value, key)=>map((file)=>({
                fieldId: key,
                ...file
            }), pathOr([], value, formData))))(fileInputsWithPath);
export default getFlattenFiles;
